import { type ReactElement } from 'react';

import { WarningIcon } from '../../icons';

interface IErrorMessageProps {
  readonly message: string | ReactElement;
}

export function ErrorMessage({ message }: IErrorMessageProps) {
  return (
    <div className="mt-1 flex items-center gap-2 text-sm text-alert-negative-primary">
      <WarningIcon className="w-5 h-5 shrink-0" />
      <span>{message}</span>
    </div>
  );
}
